export enum LogLevel {
    All = 0,
    Debug = 1,
    Info = 2,
    Warn = 3,
    Error = 4,
    Fatal = 5,
    Off = 6
}



// WEBPACK FOOTER //
// ./src/app/services/shared/log-level.enum.ts